import React, { type ComponentType, type FC } from "react";
import { FrontendApiConfigProvider as BaseFrontendApiConfigProvider } from "@edreamsodigeo/frontend-api-client";
import { withModuleContext } from "@edreamsodigeo/frontend-core";
import schema from "@edreamsodigeo/frontend-graphql-contract";
import { PrismaProvider } from "@edreamsodigeo/prisma-design-system";

import { MODULE_NAMESPACE } from "../constants/constants";

const withFrontendApiConfigProvider =
  <P extends object>(Component: ComponentType<P>): FC<P> =>
  (props: P) => (
    <BaseFrontendApiConfigProvider
      graphQLEndpoint="/frontend-api/service/graphql"
      schema={schema}
    >
      <Component {...props} />
    </BaseFrontendApiConfigProvider>
  );

const withAuthModuleContext = withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});

const withAuthContext = <P extends object>(Component): FC<P> =>
  withAuthModuleContext(withFrontendApiConfigProvider(Component));

export default withAuthContext;
